import createSvgIcon from '../Utils/CreateSvgIcon';

export const Calendar = createSvgIcon(
  <path d="M9 2H7V4H5H3V6V20V22H5H19H21V20V6V4H19H17V2H15V4H9V2ZM5 6H19V20H5V6ZM7 8H9V10H7V8ZM13 8H11V10H13V8ZM15 8H17V10H15V8ZM9 12H7V14H9V12ZM11 12H13V14H11V12ZM17 12H15V14H17V12ZM7 16H9V18H7V16ZM13 16H11V18H13V16ZM15 16H17V18H15V16Z" />,
  'Calendar',
);
